<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import {getUser} from "./api/http/user"
export default {
  name: 'App',
  data(){
    return{

    }
  },
  created(){
  },
  methods:{
  }
}
</script>

<style lang="scss">
* {
  font-family: "Helvetica Neue";
}
</style>



// WEBPACK FOOTER //
// src/App.vue